import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'sbc-exhibitor-entry',
  templateUrl: './exhibitor-entry.component.html',
  styleUrls: ['./exhibitor-entry.component.scss'],
})
export class ExhibitorEntryComponent {
  @Input() exhibitor!: ExhibitorEntry;
  @Input() isExtended = false;
  private _onExhibitorSelected: EventEmitter<ExhibitorEntry> = new EventEmitter<ExhibitorEntry>();
  @Output() onExhibitorSelected: Observable<ExhibitorEntry> = this._onExhibitorSelected.asObservable();

  private _onCategorySelected: EventEmitter<string> = new EventEmitter<string>();
  @Output() onCategorySelected: Observable<string> = this._onCategorySelected.asObservable();

  selectExhibitor(exhibitor: ExhibitorEntry) {
    this._onExhibitorSelected.next(exhibitor);
  }

  selectCategory(categoryId: string) {
    this._onCategorySelected.next(categoryId);
  }

  bookMeeting(calendlyLink: string) {
    window.Calendly.initPopupWidget({ url: calendlyLink });
  }
}
